<template>
	<div>
		<v-card class="shadowCard text--center">
			<v-img src="@/assets/backgrounds/encuesta.jpg"
				class="align-center"
			>
				<v-card-title>
					<v-spacer></v-spacer>
			  	<span class="text-h5 text--center white--text" align="center">Encuesta disponible</span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-actions>
					<v-spacer></v-spacer>
					<a class="more-link text-caption" @click="dialogEncuesta = true">Contestar encuesta</a>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-img>
		</v-card>

		<v-dialog
      v-model="dialogEncuesta"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Encuesta
        </v-card-title>
        <v-card-text>

        	<span class="text-body-1 text--justify">
        		Hola, el objetivo de esta encuesta es brindarte un mejor servicio y para ello, hemos preparado unas preguntas para conocer tus preferencias y así poder brindarte nuevas herramientas en la meta de aprender inglés.
        	</span>

        	<br/>
        	<br/>
        	<br/>
        	<!-- Pregunta #1 -->
        	<label><strong>¿Actualmente vives en Nuevo León?</strong></label>
        	<v-radio-group v-model="radica_nuevoleon" row class="mb-4">
        	  <v-radio
			        label="Sí"
			        :value="1"
			      ></v-radio>
			      <v-radio
			        label="No"
			        :value="2"
			      ></v-radio>
        	</v-radio-group>		

        	<!-- Pregunta #2 -->
        	<label v-if="radica_nuevoleon && radica_nuevoleon == 1"><strong>¿Te gustaría llevar tus clases de manera presencial?</strong></label>
        	<v-radio-group v-model="presencial" row v-if="radica_nuevoleon == 1">
        	  <v-radio
			        label="Sí"
			        :value="1"
			      ></v-radio>
			      <v-radio
			        label="No"
			        :value="2"
			      ></v-radio>
        	</v-radio-group>	

        	<!-- Pregunta #3 -->
        	<label v-if="presencial || radica_nuevoleon && radica_nuevoleon == 2"><strong>Elige la sucursal más cercana para ti, si tienes duda de la dirección de las sucursales, da clic 
        		<v-chip href="https://fastenglish.com.mx/" target="_blank">aquí.</v-chip></strong>
        	</label>
        	<v-radio-group v-model="plantel" small column v-if="presencial == 1 && radica_nuevoleon == 1">
        	  <v-radio
			        label="Apodaca"
			        :value="7"
			      ></v-radio>
			      <v-radio
			        label="Noria"
			        :value="8"
			      ></v-radio>
			      <v-radio
			        label="Romulo Garza"
			        :value="9"
			      ></v-radio>
			      <v-radio
			        label="Linda vista"
			        :value="10"
			      ></v-radio>
			      <v-radio
			        label="Eloy cabazos"
			        :value="11"
			      ></v-radio>
			      <v-radio
			        label="Mitras"
			        :value="12"
			      ></v-radio>
			      <v-radio
			        label="Universidad"
			        :value="14"
			      ></v-radio>
        	</v-radio-group>

        	<v-radio-group v-model="plantel" column v-if="presencial == 2 || radica_nuevoleon && radica_nuevoleon == 2">
        	  <v-radio
			        label="Online"
			        :value="16"
			      ></v-radio>
        	</v-radio-group>	

        	<!-- Pregunta #4 -->
        	<label v-if="plantel"><strong>¿Qué días tienes disponible para estudiar?</strong></label>
        	<v-radio-group v-model="frecuencia" column v-if="plantel">
        	  <v-radio
			        label="Lunes a Viernes"
			        :value="1"
			      ></v-radio>
			      <v-radio
			        label="Sabados"
			        :value="2"
			      ></v-radio>
			      <v-radio
			        label="Domingos"
			        :value="3"
			      ></v-radio>
        	</v-radio-group>	

        	<!-- Pregunta #4 -->
        	<label v-if="frecuencia" class="mb-2"><strong>¿Qué horarios tienes disponible para estudiar?</strong></label>
        	<v-row v-if="frecuencia" class="mt-2">
        		<v-col cols="6">
        			<v-text-field
        			  outlined
        			  dense
        			  v-model="inicio"
        			  label="Inicio"
        			  type="time"
        			></v-text-field>
        		</v-col>

        		<v-col cols="6">
        			<v-text-field
        			  outlined
        			  dense
        			  v-model="final"
        			  label="Final"
        			  type="time"
        			></v-text-field>
        		</v-col>
        	</v-row>
        	</v-radio-group>	

        	<!-- Pregunta #6 -->
        	<label v-if="inicio && final" class="mb-2"><strong>¿Por qué plataforma o medio realizas tus ejercicios?</strong></label>
        	<v-radio-group v-model="dispositivo" column v-if="inicio && final">
        	  <v-radio
			        label="Plataforma web"
			        :value="1"
			      ></v-radio>
			      <v-radio
			        label="Dispositivo Android"
			        :value="2"
			      ></v-radio>
			      <v-radio
			        label="Dispositivo iOS"
			        :value="3"
			      ></v-radio>
        	</v-radio-group>	
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            dark
            rounded
            @click="dialogEncuesta = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            @click="enviarDatos()"
            v-if="radica_nuevoleon && radica_nuevoleon == 2 && plantel && frecuencia && inicio && final && dispositivo"
          >
            Guardar
          </v-btn>

          <v-btn
            color="primary"
            rounded
            @click="enviarDatos()"
            v-if="radica_nuevoleon && radica_nuevoleon == 1 && presencial && plantel && frecuencia && inicio && final && dispositivo"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</div>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
	import { Clipboard } from '@capacitor/clipboard';
  import { Share } from '@capacitor/share';


	export default {
		props:[
			'encuestaPresencial'
	  ],

	  data: () => ({
	  	dialogEncuesta: false,
	  	radica_nuevoleon:null,
	  	presencial: null,
	  	plantel: null,
	  	frecuencia: null,
	  	inicio:null,
	  	final: null,
	  	dispositivo: null
	  }),

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{
      async enviarDatos( ){
      	const payload = {
      		id_alumno:        this.getUsuarioLMS.id,
      		radica_nuevoleon: this.radica_nuevoleon ? this.radica_nuevoleon : 0,
      		presencial:       this.presencial ? this.presencial : 0,
      		plantel:          this.plantel ? this.plantel : 0,
      		inicio:           this.inicio ? this.inicio : 0,
      		final:            this.final ? this.final : 0,
      		frecuencia:       this.frecuencia ? this.frecuencia : 0,
      		dispositivo:      this.dispositivo ? this.dispositivo : 0,
      	}

      	this.$http.post('encuestas.presencial', payload ).then( response => {
      		this.dialogEncuesta = false
      		this.encuestaPresencial.visible = false

        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      }
    }
  }
</script>



<style scoped>
  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }


  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button:increment,.v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button{
    display: none;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

</style>